import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import { Flavor } from '../../common/types';
import useModalStore from './useModalStore';
import useFlavorStore from '../../common/store/useFlavorStore';

const Wrapper = styled.div`
  padding: 20rem 0;
  flex-shrink: 0;

  display: flex;
  justify-content: center;
`;

const Button = styled.button(({ $flavor, $color }: {
  $flavor: Flavor,
  $color: string
}) => `
  padding: 15rem 35rem;
  background: var(--${$flavor});

  outline: none;
  border: none;
  border-radius: 10rem;

  color: ${$color};
  cursor: pointer;

  transition: 0.25s opacity;

  &:hover {
    opacity: 0.8;
  }
`);


const Footer = () => {

  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const close = useModalStore(useCallback(state => state.close, []));

  let color: string;

  switch (flavor) {
    case "pear":
    case "elderflower":
      color = "black";
      break;
    default:
      color = "white";
  }


  return (
    <Wrapper>
      <Button
        onClick={() => close && close()}
        $flavor={flavor}
        $color={color}
      >
        Okay
      </Button>
    </Wrapper>
  );
}

export default React.memo(Footer);